import React from 'react'
import { useMutation } from '@tanstack/react-query'
import { Button, ButtonVariant } from '../../../../components/common/Button'
import { IconChoices } from '../../../../components/common/Icon'
import { useToastNotifications } from '../../../../hooks/useToastNotification'
import { ToastType } from '../../../../components/common/Toast/toast-type'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import {
  downloadAdminBoardMembersEmailList,
  downloadSocietyList,
} from '../../../../api/admin'

export const DataExport = (): React.ReactNode => {
  const { setToastNotification } = useToastNotifications()
  const { translate } = useAppTranslation()

  const {
    mutate: mutateDownloadSocietyList,
    isPending: isDownloadingSocietyList,
  } = useMutation({
    mutationFn: downloadSocietyList,
    onError: () => {
      setToastNotification(
        ToastType.DANGER,
        translate('flashMessage.somethingWentWrongError')
      )
    },
  })

  const {
    mutate: mutateDownloadAdminBoardMembersEmailList,
    isPending: isDownloadingAdminBoardMembersEmailList,
  } = useMutation({
    mutationFn: downloadAdminBoardMembersEmailList,
    onError: () => {
      setToastNotification(
        ToastType.DANGER,
        translate('flashMessage.somethingWentWrongError')
      )
    },
  })

  const downloadSociety = (): void => {
    mutateDownloadSocietyList()
  }

  const downloadEmail = (): void => {
    mutateDownloadAdminBoardMembersEmailList()
  }

  return (
    <div className="flex flex-col items-start gap-4">
      <Button
        variant={ButtonVariant.PRIMARY}
        icon={IconChoices.DOWNLOAD}
        label="Statistik över föreningar"
        onClick={downloadSociety}
        loading={isDownloadingSocietyList}
        className="w-[26rem] max-w-full"
        wrapperClassName="block"
        justifyContent="justify-start"
      />
      <Button
        variant={ButtonVariant.PRIMARY}
        icon={IconChoices.DOWNLOAD}
        label="Epost för styrelse och administratörer"
        onClick={downloadEmail}
        loading={isDownloadingAdminBoardMembersEmailList}
        className="w-[26rem] max-w-full"
        wrapperClassName="block"
        justifyContent="justify-start"
      />
    </div>
  )
}
